// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"ea72a1b0ea04de9f53d9","655":"2dd23f91581a0dce3803"}[chunkId] + ".js";
};